export default __webpack_public_path__ + "static/lopez-8a57e2278b3f82186d315fa0fb308734.jpg";